export enum ErrorTypes {
  ACCOUNT_EXISTS = "account-exists",
  ACCOUNT_UNKNOWN = "account-unknown",
  USER_EXISTS = "user-exists",
  USER_UNKNOWN = "user-unknown",
  EMAIL_EXISTS = "email-exists",
  INVALID_PARAMETERS = "invalid-parameters",
  UNAUTHORIZED = "unauthorized",
  ACCOUNT_CREATION_FAILED = "account-creation-failed",
  ACCOUNT_UPDATE_FAILED = "account-update-failed",
  USER_CREATION_FAILED = "user-creation-failed",
  USER_UPDATE_FAILED = "user-update-failed",
  USER_DELETION_FAILED = "user-deletion-failed",
  USER_PASSWORD_UPDATE_FAILED = "user-password-update-failed",
  USER_PREFERENCES_UPDATE_FAILED = "user-preferences-update-failed",
  USER_DISABLED = "user-disabled",
  USER_NOT_FOUND = "user-not-found",
  USERS_NOT_FOUND = "users-not-found",
  UNKNOWN = "unknown",
  NOT_FOUND = "not-found",
  LOCATION_EXISTS = "location-exists",
  DUPLICATE_ENTRY = "duplicate-entry",
  PROCESSING_ERROR = "processing-error",
  INVALID_ENTITY = "invalid-entity",
  NO_PERMISSION_ENTITY = "no-permission-entity",
  INVALID_MANAGEMENT_UNIT = "invalid-management-unit",
  MISSING_COORDINATES = "missing-coordinates",
  MANAGEMENT_UNIT_ENTITY_MISMATCH = "management-unit-entity-mismatch",
  INVALID_DROPDOWN_VALUE = "invalid-dropdown-value",
}